export class CreateMPARequestReviewRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "decision",
            "baseName": "decision",
            "type": "MPAReviewSubmitDecision",
            "format": ""
        },
        {
            "name": "comment",
            "baseName": "comment",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CreateMPARequestReviewRequest.attributeTypeMap;
    }
    constructor() {
    }
}
